import React from 'react';
import { CompositeDecorator } from 'draft-js';
import LinkWrapper from '../ui/components/Link/LinkWrapper';

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
};

export const decorators = (
  setEditorLinkModalData,
  setEditorInformationLinkModalData,
  setEditorState,
  editorStateSelector,
  setEditorPhoneModalData
) => {
  return new CompositeDecorator([
    {
      strategy: findLinkEntities,
      component: (props) => (
        <LinkWrapper
          {...props}
          editorStateSelector={editorStateSelector}
          setEditorLinkModalData={setEditorLinkModalData}
          setEditorInformationLinkModalData={setEditorInformationLinkModalData}
          setEditorState={setEditorState}
          setEditorPhoneModalData={setEditorPhoneModalData}
        />
      ),
    },
  ]);
};
